import { AuthContext } from 'Contexts/AuthContext';
import React, { useContext } from 'react';

const useAuth = () => {
    return useContext(AuthContext);
}

export default useAuth;